/**
 * Mutations for wordpress/pages module
 */
import types from './types'
import {isUpdatedComponent, migrateComponents} from '@/helpers'

/**
 * 親ページ
 *   子ページ
 *   子ページ
 * のように並べ替える
 */
function swapPages (pages) {
  /**
   * parent = 0のページをswappedに格納、各ページでhierarchyを0にセット
   * parent != 0のページをrestに格納
   */
  const swapped = pages.filter(item => item.parent === 0).map(page => ({...page, hierarchy: 0}))
  let rest = pages.filter(item => item.parent !== 0)
  let hierarchy = 0
  while (rest.length > 0) {
    const remaining = []
    hierarchy += 1
    for (let index = 0; index < rest.length; index++) {
      const parentIndex = swapped.findIndex(parent => parent.id === rest[index].parent)
      /**
       * page.parentがswapped配列に見つかった場合は
       * swappedに入っている同じparentをもつページを数え、
       * 兄弟ページの数だけ挿入位置をずらす
       */
      if (~parentIndex) {
        const siblings = swapped.filter(page => page.parent === rest[index].parent)
        swapped.splice(parentIndex + siblings.length + 1, 0, {...rest[index], hierarchy})
      } else {
        remaining.push(rest[index])
      }
    }
    rest = remaining
  }
  return swapped
}

const mutations = {
  [types.FETCH]: (state, payload) => {
    payload = payload.map(page => {
      page.components = migrateComponents(page.components)
      return page
    })
    state.pages = payload
    state.pages = swapPages(state.pages)
  },
  [types.CREATE]: (state, payload) => {
    if (!state.pages.some(id => id === payload.id)) {
      state.pages.unshift(payload)
    }
    state.pages = swapPages(state.pages)
  },
  // [types.PAGE_CREATE]: (state, payload) => {
  //   let updatedPages = [...state.pages]
  //   if (!state.pages.some(id => id === payload.id)) {
  //     updatedPages.unshift(payload)
  //   }
  //   state.pages = swapPages(updatedPages)
  // },
  [types.UPDATE]: (state, payload) => {
    state.pages[state.pages.findIndex(page => page.id === payload.id)] = payload
    state.pages = swapPages(state.pages)
  },
  [types.DELETE]: (state, payload) => {
    state.pages.splice(state.pages.findIndex(page => page.id === payload.id), 1)
    state.pages = swapPages(state.pages)
  },
  [types.SELECT]: (state, payload) => {
    state.selected = state.pages[state.pages.findIndex(page => page.id === +payload)]
    // state.selected.components内のコンポーネントで最新でないものをフィルターする
    if (state.selected.components) state.selected.components = state.selected.components.filter(component => isUpdatedComponent(component))
  },
  [types.DESELECT]: (state, payload) => {
    state.selected = null
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/modules/wordpress/pages/mutations.js